//  MODULES
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app-routing.module';

// LIBRERIAS INSTALADAS
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { LazyLoadImageModule } from 'ng-lazyload-image';

// COMPONENTS
import { BannerComponent } from '@components/banner/banner.component';
import { TabsComponent } from '@components/tabs/tabs.component';
import { FormsComponent } from '@components/forms/forms.component';
import { FormsErrorComponent } from '@components/forms-error/forms-error.component';
import { FeaturesComponent } from '@components/features/features.component';
import { CarouselComponent } from '@components/carousel/carousel.component';
import { TitleSectionComponent } from '@components/title-section/title-section.component';
import { AccordionComponent } from '@components/accordion/accordion.component';

// DIRECTIVES
import { ValidationDirective } from '@directives/validation.directive';

@NgModule({
  declarations: [
    BannerComponent,
    TabsComponent,
    FormsComponent,
    FormsErrorComponent,
    FeaturesComponent,
    CarouselComponent,
    TitleSectionComponent,
    AccordionComponent,
    ValidationDirective,
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    SlickCarouselModule,
    LazyLoadImageModule,
    AppRoutingModule,
  ],
  exports: [
    BannerComponent,
    TabsComponent,
    FormsComponent,
    FormsErrorComponent,
    FeaturesComponent,
    CarouselComponent,
    TitleSectionComponent,
    AccordionComponent,
    ValidationDirective,
  ],
})
export class ComponentsModule {}
